import type { PayPalNamespace } from "@paypal/paypal-js";
import $ from "jquery";
const ApplePaySession = (window as any).ApplePaySession;

type PayPalApplePayNamespace = PayPalNamespace & { Applepay: any };

let applePay: any;
let applePayConfig: any;

export async function initApplePay(paypal: PayPalNamespace) {
  if (location.protocol === "https:") {
    await init(paypal as PayPalApplePayNamespace);
  }
}

async function init(paypal: PayPalApplePayNamespace) {
  const displayName = "RostRoth GbR";
  let applePaySession: any;
  let totalAmount = "";

  try {
    if (!(await supportsApplePay())) {
      return;
    }

    applePay = paypal.Applepay();
    applePayConfig = await applePay.config();

    if (applePayConfig.isEligible) {
      setupApplePayButton();
    }
  } catch (e) {
    console.error(e);
  }

  function setupApplePayButton() {
    totalAmount = $("#applepay-container").data("total-amount");

    $('<apple-pay-button id="apple-pay-button" type="plain" />')
      .appendTo("#applepay-container")
      .on("click", onClickApplePayButton);
  }

  function onClickApplePayButton() {
    const paymentRequest = {
      countryCode: applePayConfig.countryCode,
      merchantCapabilities: applePayConfig.merchantCapabilities,
      supportedNetworks: applePayConfig.supportedNetworks,
      currencyCode: "EUR",
      requiredShippingContactFields: ["name", "phone", "postalAddress"],
      requiredBillingContactFields: ["postalAddress"],
      total: {
        label: displayName,
        type: "final",
        amount: totalAmount,
      },
    };

    applePaySession = new ApplePaySession(4, paymentRequest);
    applePaySession.onvalidatemerchant = onValidateMerchant;
    applePaySession.onpaymentauthorized = onPaymentAuthorized;
    applePaySession.oncancel = onCancel;
    applePaySession.begin();
  }

  async function onValidateMerchant(event: any) {
    try {
      const result = await applePay.validateMerchant({
        validationUrl: event.validationURL,
        displayName,
      });

      applePaySession.completeMerchantValidation(result.merchantSession);
    } catch (err) {
      console.error(err);
      applePaySession.abort();
    }
  }

  async function onPaymentAuthorized(event: any) {
    try {
      const paymentEvent = event.payment;
      const orderId = await createOrder();

      try {
        await applePay.confirmOrder({
          orderId,
          token: paymentEvent.token,
          billingContact: paymentEvent.billingContact,
        });

        await authorizePayment();

        applePaySession.completePayment(ApplePaySession.STATUS_SUCCESS);

        proceedToThankYou();
      } catch (err) {
        applePaySession.completePayment(ApplePaySession.STATUS_FAILURE);
        throw err;
      }
    } catch (err) {
      console.error(err);
    }
  }

  function onCancel(_event: any) {
    console.warn("Apple Pay canceled");
  }
}

async function createOrder() {
  const result = await callAction("create-order");

  if (result?.id == null) {
    console.warn("Create order failed", result);
    throw new Error("Create order failed");
  }

  return result?.id;
}

async function authorizePayment() {
  const result = await callAction("authorize-payment");

  if (!result || !result.id) {
    throw new Error("Failure authorizing payment (Apple Pay via PayPal).");
  }

  return result.id;
}

function proceedToThankYou() {
  $("input[name=paypal-advanced-payment-via]").val("apple-pay");

  $("button[name=payment][value=paypal-advanced]")
    .attr("disabled", null)
    .trigger("click");
}

async function callAction(action: string) {
  const response = await fetch(location.pathname, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: new URLSearchParams({
      action,
      payment: "paypal-advanced",
      "payment-via": "apple-pay",
    }).toString(),
  });

  return await response.json();
}

async function supportsApplePay() {
  if (ApplePaySession == null) {
    throw new Error("Apple Pay not loaded.");
  }

  if (!(await ApplePaySession.canMakePayments())) {
    throw new Error("Apple Pay not supported.");
  }

  return true;
}
